import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    description: 'ShipStation accept terms modal title',
    defaultMessage: 'Action Required',
    id: 'cZnCDp',
  },
  modalHeader: {
    description: 'ShipStation accept terms modal header',
    defaultMessage: 'New ShipStation Terms of Service',
    id: 'rV8Its',
  },
  modalBodyAdmin: {
    description: 'ShipStation accept terms modal body for admins',
    defaultMessage: "We've updated our Terms of Service and Privacy Policy. We encourage you to read these documents carefully.",
    id: 'PYg7A8',
  },
  modalBodyNonAdmin: {
    description: 'ShipStation accept terms modal body for non-admins',
    defaultMessage:
      "We've updated our Terms of Service and Privacy Policy. Contact your administrator to accept new terms and re-enable your ShipStation access.",
    id: 'fGA4eD',
  },
  modalBodyAccept: {
    description: 'ShipStation accept terms modal terms accept checkbox label',
    defaultMessage: 'I have read and agree to the following terms of service:',
    id: 'UQBLbA',
  },
  modalBodyTerms: {
    description: 'ShipStation accept terms modal terms link',
    defaultMessage: 'ShipStation Terms of Service',
    id: '/lfZUI',
  },
  modalBodyPrivacy: {
    description: 'ShipStation accept terms modal privacy link',
    defaultMessage: 'Privacy Policy',
    id: 'L7nJX+',
  },
  modalCtaButton: {
    description: 'ShipStation accept terms modal cta button',
    defaultMessage: 'Accept Terms',
    id: 'vj91WF',
  },
  acceptError: {
    description: 'ShipStation accept terms modal accept api error label',
    defaultMessage: 'Error accepting terms. Please try again later.',
    id: '/LN0/E',
  },
  applicationBlocked: {
    description: 'ShipStation accept terms modal accept api error label',
    defaultMessage: 'Access to ShipStation is blocked.',
    id: 'AoWTT6',
  },
});
